module.exports = __webpack_public_path__ + "img/flowers-6924088_1280_thumb.b99c4dd4.png";